module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmYUtfABc4EsA.40d83d8a.woff2";